<div class="dialog-container">
    <h2 mat-dialog-title>Data Overzicht</h2>

    <mat-dialog-content>
        <p>Aantal features: {{data.features.length}}</p>

        <div class="table-container">
            <table class="data-table">
                <thead>
                    <tr>
                        @for (prop of data.shapefileProperties; track prop) {
                            <th>{{prop}}</th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (feature of data.features; track feature) {
                        <tr>
                            @for (prop of data.shapefileProperties; track prop) {
                                <td>{{feature.properties[prop]}}</td>
                            }
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="onClose()">Sluiten</button>
    </mat-dialog-actions>
</div>
